import * as Yup from "yup";
import { tt } from "../../../../utils/i18n/i18n";
import yupValidateInternationalPhoneNumber from "../../../../utils/helpers/yupValidateInternationalPhoneNumber";

const infoOnboardingSchema = Yup.object({
  contactPhoneNumber: Yup.string()
    .required(tt("phone_required"))
    .test(
      "is-valid-phone",
      tt("validPhoneNumberMessage"),
      function (value, { createError }) {
        return yupValidateInternationalPhoneNumber(
          "contactPhoneNumber",
          value,
          createError
        );
      }
    )
});

export { infoOnboardingSchema };
